
class textBlockSection {
  constructor() {  
    this.init();
  }
  init = () => {
    let textBlocks = document.querySelectorAll('.text-block-section');
    textBlocks && textBlocks.length > 0 && textBlocks.forEach(block => {
      this.clickEvents(block);
    })
  }
  clickEvents = (block) => {
    let readMoreBtn = block.querySelector('.read-more-js');
    let readLess = block.querySelector('.read-less-js');
    let readMoreWrapper = block.querySelector('.read-more-wrapper-js');
    let readLessWrapper = block.querySelector('.read-less-wrapper-js');
    readMoreBtn?.addEventListener('click',(e) => {
      e.preventDefault();
      readMoreWrapper.classList.add('hide');
      let blocks = block.querySelectorAll('.block-item-js');
      blocks && blocks.length>0 && blocks.forEach(block => {
        block.classList.remove('hide');
      })
      readLessWrapper.classList.remove('hide');
    })
    
    readLess?.addEventListener('click',(e) => {
      e.preventDefault();
      readLessWrapper.classList.add('hide');
      let blocks = block.querySelectorAll('.block-item-js');
      blocks && blocks.length>0 && blocks.forEach(block => {
        block.classList.add('hide');
      })
      readMoreWrapper.classList.remove('hide');
    })
  }
}
new textBlockSection;